import CloseIcon from '@material-ui/icons/Close'
import { LoadingButton } from '@mui/lab'
import { IconButton } from '@mui/material'
import TextFieldText from 'components/Inputs/TextField/Text'
import { Mask } from 'helpers/Masks'
import ValidateSchema from 'helpers/ValidateSchema'
import { useSnackbar } from 'notistack'
import React from 'react'
import { Field, Form } from 'react-final-form'
import { useParams } from 'react-router-dom'
import AuthenticationService from 'services/Authentication'
import { useTheme } from 'styled-components'
import * as Yup from 'yup'
import { ButtonSubmit, Content, InputFormText } from './styles'

function RecoveryPassword() {
  const { usernameOfPartner } = useParams()
  if (!usernameOfPartner) window.location.replace('/auth')

  const { enqueueSnackbar, closeSnackbar } = useSnackbar()
  const theme = useTheme()

  const loginSchema = Yup.object({ login: Yup.string().required('Por favor insira um login') })

  const handleSubmitValues = async (values: any) => {
    const { login } = values

    try {
      const response = await AuthenticationService.authenticationController.recoveryPassword({ login })
      window.location.reload()
      console.log(response)
    } catch (error: any) {
      let message = 'Username não encontrado'
      if (Number(error.response.status) >= 500) message = 'Servidor temporariamente indisponível.'
      if (error.code === 'ECONNABORTED') message = 'Conexão de internet perdida.'
      if (error.response.status !== 400) message = 'Erro desconhecido, entre em contato com seu provedor.'
      enqueueSnackbar(message, {
        variant: 'error',
        anchorOrigin: {
          vertical: 'top',
          horizontal: 'right',
        },
        autoHideDuration: 5000,
        action: (
          <IconButton onClick={() => closeSnackbar()} size='large'>
            <CloseIcon />
          </IconButton>
        ),
      })
    }
  }

  return (
    <Form
      onSubmit={handleSubmitValues}
      validate={ValidateSchema(loginSchema)}
      initialValues={{ login: `${usernameOfPartner}.` }}
      render={({ handleSubmit, submitting }) => {
        return (
          <form onSubmit={handleSubmit} autoComplete='off'>
            <Content>
              <InputFormText>
                <Field name='login'>
                  {({ input, meta }) => (
                    <TextFieldText
                      error={meta.error && meta.touched}
                      autoComplete='false'
                      id='login'
                      label='Username'
                      type='text'
                      value={input.value}
                      mask={(e) => Mask.prefix(usernameOfPartner as string, '.', e)}
                      onChange={(e) => input.onChange(e)}
                      InputProps={{
                        style: { marginTop: '5px' },
                        sx: {
                          '& fieldset': {
                            '& legend': {
                              display: 'none',
                            },
                          },
                        },
                      }}
                      InputLabelProps={{
                        style: {
                          position: 'relative',
                          display: 'contents',
                        },
                        shrink: true,
                      }}
                      helperText={meta.error}
                      size='small'
                      margin='dense'
                      placeholder='Username'
                    />
                  )}
                </Field>
              </InputFormText>
              <ButtonSubmit>
                <LoadingButton
                  loading={submitting}
                  type='submit'
                  variant='contained'
                  sx={{
                    color: 'white',
                    backgroundColor: theme.colors.primary.main,
                    textTransform: 'none',
                    ':hover': { opacity: 0.85, backgroundColor: theme.colors.primary.hover },
                  }}
                >
                  Enviar
                </LoadingButton>
              </ButtonSubmit>
            </Content>
          </form>
        )
      }}
    />
  )
}

export default RecoveryPassword
